import React, { useEffect, useState, Suspense } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

// layouts

// views without layouts
// Lazy load components
const Landing = React.lazy(() => import("views/Landing.js"));
const Newsletter = React.lazy(() => import("views/Newsletter"));
const Terms = React.lazy(() => import("views/Terms"));
const Privacy = React.lazy(() => import("views/Privacy"));
const PodcastPage = React.lazy(() => import("views/PodcastPage"));
const AffiliateDashboard = React.lazy(() => import("views/AffiliateDashboard"));
const BookPage = React.lazy(() => import("views/BookPage"));
const RecommendedBooks2025 = React.lazy(() => import("views/RecommendedBooks2025"));

function App() {

    return (
        <Suspense fallback={
            <div className="flex h-screen items-center justify-center">
                <div className="h-32 w-32 animate-spin rounded-full border-b-2 border-gray-900"></div>
            </div>
        }>
            <Routes>
                <Route path="/" element={<Landing pageName={''} />} />
                <Route path="/libros" element={<Landing pageName={'libros'} />} />
                <Route path="/libros-recomendados-2025" element={<RecommendedBooks2025 />} />
                <Route path="/landing" element={<Landing />} />
                <Route path="/newsletter" element={<Newsletter />} />
                <Route path="/:podcastId" element={<PodcastPage />} />
                <Route path="/libro/:slug" element={<BookPage />} />
                <Route path="/admin/affiliates" element={<AffiliateDashboard />} />
            </Routes>
        </Suspense>
    );

}

export default App;